import React from "react";
import { Divider, Header, Icon } from "semantic-ui-react";

const TableTitle = ({ title, icon,color="#000000",iconPath }) => {
  return (
    <Divider horizontal>
     
        <img src={iconPath} alt="" height={25} /> <br/> <span style={{ color:color }}>{title}</span>
     
    </Divider>
  );
};

export default TableTitle;
